// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__27XtI","right":"styles_right__s8y8x"};